import React from "react";

export default (props) => {
  return (
    <div className="h-full p-0 bg-gray-500 border border-gray-600 rounded-lg shadow-xl lg:w-full">
      <div className="relative justify-end w-full h-full px-8 py-4 overflow-hidden text-center bg-white rounded-lg">{props.children}</div>
    </div>
  );
};
